import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68828949"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "flex gap-3 flex-row justify-between items-start" }
const _hoisted_4 = { class: "text-lg text-[#101828] font-semibold mb-0" }
const _hoisted_5 = { class: "mb-6 text-[#475467] font-medium text-sm" }
const _hoisted_6 = { class: "flex flex-row w-full justify-end" }
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = { class: "flex justify-between items-center w-full" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "font-semibold mr-2" }
const _hoisted_11 = { class: "bg-[#EDF4FF] border border-[#A9CDFF] rounded-full py-1 px-2 w-[90px] text-center text-[#004EEB] text-xs font-medium mr-4" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "inline-flex items-center cursor-pointer mr-4" }
const _hoisted_14 = ["checked", "disabled", "onChange"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-11 h-6 bg-[#F2F4F7] peer-focus:outline-none rounded-full peer dark:bg-[#F2F4F7] peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#155EEF]" }, null, -1))
const _hoisted_16 = { class: "text-[#475467] font-semibold text-sm" }
const _hoisted_17 = {
  key: 0,
  width: "24",
  height: "21",
  viewBox: "0 0 24 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7 13L12 8L17 13H7Z",
  fill: "#101828"
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  width: "24",
  height: "21",
  viewBox: "0 0 24 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M7 8L12 13L17 8H7Z",
  fill: "#101828"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "flex item-center justify-between mt-6" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "me-2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = { class: "p-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
      fill: "#DCFAE6"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M34 33V31C34 29.1362 32.7252 27.5701 31 27.126M27.5 15.2908C28.9659 15.8841 30 17.3213 30 19C30 20.6787 28.9659 22.1159 27.5 22.7092M29 33C29 31.1362 29 30.2044 28.6955 29.4693C28.2895 28.4892 27.5108 27.7105 26.5307 27.3045C25.7956 27 24.8638 27 23 27H20C18.1362 27 17.2044 27 16.4693 27.3045C15.4892 27.7105 14.7105 28.4892 14.3045 29.4693C14 30.2044 14 31.1362 14 33M25.5 19C25.5 21.2091 23.7091 23 21.5 23C19.2909 23 17.5 21.2091 17.5 19C17.5 16.7909 19.2909 15 21.5 15C23.7091 15 25.5 16.7909 25.5 19Z",
      stroke: "#079455",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_28 = { class: "mt-5 text-center" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_34 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_35 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#53DDC9",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M59.9167 25H33.375C31.1292 25 29.2917 26.8375 29.2917 29.0833V47.4583C29.2917 48.5413 29.7219 49.5799 30.4876 50.3457C31.2534 51.1115 32.292 51.5417 33.375 51.5417H59.9167C62.1829 51.5417 64 49.7246 64 47.4583V29.0833C64 28.0004 63.5698 26.9618 62.804 26.196C62.0382 25.4302 60.9996 25 59.9167 25ZM59.9167 47.4583H33.375V32.4929L46.6458 39.2917L59.9167 32.4929V47.4583ZM46.6458 35.8413L33.375 29.0833H59.9167L46.6458 35.8413ZM25.2083 47.4583C25.2083 47.8054 25.2696 48.1321 25.3104 48.4792H17.0417C15.9147 48.4792 15 47.5604 15 46.4375C15 45.3146 15.9147 44.3958 17.0417 44.3958H25.2083V47.4583ZM21.125 28.0625H25.3104C25.2696 28.4096 25.2083 28.7362 25.2083 29.0833V32.1458H21.125C20.0021 32.1458 19.0833 31.2271 19.0833 30.1042C19.0833 28.9812 20.0021 28.0625 21.125 28.0625ZM17.0417 38.2708C17.0417 37.1479 17.9604 36.2292 19.0833 36.2292H25.2083V40.3125H19.0833C17.9604 40.3125 17.0417 39.3937 17.0417 38.2708Z",
      fill: "#53DDC9"
    })
  ])
], -1))
const _hoisted_39 = { class: "mt-6 text-center" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "text-sm text-[#475467] mb-4" }
const _hoisted_42 = { class: "text-sm text-[#475467]" }
const _hoisted_43 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_44 = {
  type: "button",
  class: "px-8 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full"
}
const _hoisted_45 = { class: "text-sm text-[#475467]" }
const _hoisted_46 = { class: "text-sm text-[#155EEF] ms-1" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_48 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_49 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#E2DFFF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7504 33.0499C26.3152 33.0499 27.8159 32.4283 28.9223 31.3219C30.0288 30.2154 30.6504 28.7147 30.6504 27.1499C30.6504 25.5851 30.0288 24.0845 28.9223 22.978C27.8159 21.8715 26.3152 21.2499 24.7504 21.2499C23.1856 21.2499 21.6849 21.8715 20.5785 22.978C19.472 24.0845 18.8504 25.5851 18.8504 27.1499C18.8504 28.7147 19.472 30.2154 20.5785 31.3219C21.6849 32.4283 23.1856 33.0499 24.7504 33.0499ZM24.7504 35.9999C25.9126 35.9999 27.0634 35.771 28.1371 35.3263C29.2109 34.8815 30.1865 34.2296 31.0083 33.4078C31.8301 32.586 32.482 31.6104 32.9267 30.5367C33.3715 29.4629 33.6004 28.3121 33.6004 27.1499C33.6004 25.9877 33.3715 24.8369 32.9267 23.7632C32.482 22.6894 31.8301 21.7138 31.0083 20.892C30.1865 20.0702 29.2109 19.4183 28.1371 18.9736C27.0634 18.5288 25.9126 18.2999 24.7504 18.2999C22.4032 18.2999 20.1522 19.2323 18.4925 20.892C16.8328 22.5517 15.9004 24.8028 15.9004 27.1499C15.9004 29.4971 16.8328 31.7481 18.4925 33.4078C20.1522 35.0675 22.4032 35.9999 24.7504 35.9999Z",
      fill: "#155EEF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M21.3701 32.7431C21.5074 32.8802 21.6164 33.0429 21.6908 33.2221C21.7651 33.4013 21.8034 33.5934 21.8034 33.7874C21.8034 33.9815 21.7651 34.1736 21.6908 34.3528C21.6164 34.532 21.5074 34.6947 21.3701 34.8317L20.373 35.8259C18.4541 37.7453 17.376 40.3482 17.3758 43.0622V48.5374C17.3758 48.9286 17.2204 49.3038 16.9438 49.5804C16.6671 49.857 16.292 50.0124 15.9008 50.0124C15.5096 50.0124 15.1344 49.857 14.8578 49.5804C14.5812 49.3038 14.4258 48.9286 14.4258 48.5374V43.0622C14.4262 39.5658 15.8152 36.2127 18.2873 33.7402L19.2815 32.7431C19.4185 32.6058 19.5813 32.4968 19.7605 32.4224C19.9397 32.3481 20.1318 32.3098 20.3258 32.3098C20.5198 32.3098 20.7119 32.3481 20.8911 32.4224C21.0703 32.4968 21.2331 32.6058 21.3701 32.7431ZM56.1565 31.8581C56.0191 31.9952 55.9101 32.1579 55.8358 32.3371C55.7614 32.5163 55.7231 32.7084 55.7231 32.9024C55.7231 33.0965 55.7614 33.2886 55.8358 33.4678C55.9101 33.647 56.0191 33.8097 56.1565 33.9467L57.1536 34.9409C58.1038 35.8912 58.8576 37.0194 59.3719 38.261C59.8861 39.5026 60.1508 40.8333 60.1508 42.1772V48.5374C60.1508 48.9286 60.3062 49.3038 60.5828 49.5804C60.8594 49.857 61.2346 50.0124 61.6258 50.0124C62.017 50.0124 62.3922 49.857 62.6688 49.5804C62.9454 49.3038 63.1008 48.9286 63.1008 48.5374V42.1772C63.1004 38.6808 61.7114 35.3277 59.2392 32.8552L58.2451 31.8581C58.1081 31.7208 57.9453 31.6118 57.7661 31.5374C57.5869 31.4631 57.3948 31.4248 57.2008 31.4248C57.0068 31.4248 56.8147 31.4631 56.6355 31.5374C56.4563 31.6118 56.2935 31.7208 56.1565 31.8581Z",
      fill: "#155EEF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M51.3002 33.0499C49.7354 33.0499 48.2347 32.4283 47.1283 31.3219C46.0218 30.2154 45.4002 28.7147 45.4002 27.1499C45.4002 25.5851 46.0218 24.0845 47.1283 22.978C48.2347 21.8715 49.7354 21.2499 51.3002 21.2499C52.865 21.2499 54.3657 21.8715 55.4721 22.978C56.5786 24.0845 57.2002 25.5851 57.2002 27.1499C57.2002 28.7147 56.5786 30.2154 55.4721 31.3219C54.3657 32.4283 52.865 33.0499 51.3002 33.0499ZM51.3002 35.9999C50.138 35.9999 48.9872 35.771 47.9134 35.3263C46.8397 34.8815 45.8641 34.2296 45.0423 33.4078C44.2205 32.586 43.5686 31.6104 43.1239 30.5367C42.6791 29.4629 42.4502 28.3121 42.4502 27.1499C42.4502 25.9877 42.6791 24.8369 43.1239 23.7632C43.5686 22.6894 44.2205 21.7138 45.0423 20.892C45.8641 20.0702 46.8397 19.4183 47.9134 18.9736C48.9872 18.5288 50.138 18.2999 51.3002 18.2999C53.6474 18.2999 55.8984 19.2323 57.5581 20.892C59.2178 22.5517 60.1502 24.8028 60.1502 27.1499C60.1502 29.4971 59.2178 31.7481 57.5581 33.4078C55.8984 35.0675 53.6474 35.9999 51.3002 35.9999ZM38.0252 45.5874C36.0692 45.5874 34.1934 46.3644 32.8103 47.7475C31.4272 49.1306 30.6502 51.0065 30.6502 52.9624V56.7974C30.6502 57.1886 30.4948 57.5638 30.2182 57.8404C29.9416 58.117 29.5664 58.2724 29.1752 58.2724C28.784 58.2724 28.4088 58.117 28.1322 57.8404C27.8556 57.5638 27.7002 57.1886 27.7002 56.7974V52.9624C27.7002 50.2241 28.788 47.5979 30.7243 45.6615C32.6606 43.7252 35.2868 42.6374 38.0252 42.6374C40.7636 42.6374 43.3898 43.7252 45.3261 45.6615C47.2624 47.5979 48.3502 50.2241 48.3502 52.9624V56.7974C48.3502 57.1886 48.1948 57.5638 47.9182 57.8404C47.6416 58.117 47.2664 58.2724 46.8752 58.2724C46.484 58.2724 46.1088 58.117 45.8322 57.8404C45.5556 57.5638 45.4002 57.1886 45.4002 56.7974V52.9624C45.4002 51.9939 45.2094 51.0349 44.8388 50.1401C44.4682 49.2454 43.9249 48.4323 43.2401 47.7475C42.5553 47.0627 41.7423 46.5194 40.8475 46.1488C39.9527 45.7782 38.9937 45.5874 38.0252 45.5874Z",
      fill: "#155EEF"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.0258 41.1625C39.5906 41.1625 41.0912 40.5409 42.1977 39.4344C43.3042 38.3279 43.9258 36.8273 43.9258 35.2625C43.9258 33.6977 43.3042 32.197 42.1977 31.0905C41.0912 29.9841 39.5906 29.3625 38.0258 29.3625C36.461 29.3625 34.9603 29.9841 33.8539 31.0905C32.7474 32.197 32.1258 33.6977 32.1258 35.2625C32.1258 36.8273 32.7474 38.3279 33.8539 39.4344C34.9603 40.5409 36.461 41.1625 38.0258 41.1625ZM38.0258 44.1125C40.3729 44.1125 42.624 43.1801 44.2837 41.5204C45.9434 39.8607 46.8758 37.6096 46.8758 35.2625C46.8758 32.9153 45.9434 30.6643 44.2837 29.0046C42.624 27.3449 40.3729 26.4125 38.0258 26.4125C35.6786 26.4125 33.4276 27.3449 31.7679 29.0046C30.1082 30.6643 29.1758 32.9153 29.1758 35.2625C29.1758 37.6096 30.1082 39.8607 31.7679 41.5204C33.4276 43.1801 35.6786 44.1125 38.0258 44.1125Z",
      fill: "#155EEF"
    })
  ])
], -1))
const _hoisted_53 = { class: "mt-6 text-center" }
const _hoisted_54 = { class: "mt-4 text-center" }
const _hoisted_55 = { class: "text-sm text-[#475467] mb-4" }
const _hoisted_56 = { class: "text-[#475467]" }
const _hoisted_57 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_58 = {
  type: "button",
  class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
}
const _hoisted_59 = { class: "text-sm text-[#475467]" }
const _hoisted_60 = { class: "text-sm text-[#155EEF] ms-1" }

import { ref, onBeforeMount, computed } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useUserStore } from "@/stores/userStore";
import ClassStructure from "@/modules/main/components/ClassStructureComponent.vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import router from "@/router";
import InternalViewNav from '@/modules/main/components/InternalViewNav.vue';
import {
  VideoCameraIcon,
} from "@heroicons/vue/24/outline";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";

// Data Stores

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewClassStructureView',
  setup(__props) {

const schoolStore = useSchoolStore();
const rolloverStore = useRolloverStore();
const userStore = useUserStore();

// Local State
const goToAssignModal = ref(false);
const completeClassReviewModal = ref(false);
const currentOpenGrade = ref<number | undefined>(0);
const showModal = ref(false);
const grades = Array.from({ length: 12 }, (_, i) => i + 1); // Grades 1 to 12
const showAddGradeConfirm = ref(false);
const selectedGrade = ref<number | null>(null);

const isInternalAdmin = computed(() => userStore.isInternalAdmin);

onBeforeMount(async () => {
  currentOpenGrade.value = schoolStore.currentSchoolStructure?.gradeLevels[0];
  console.log("currentOpenGrade", currentOpenGrade.value);

  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver && currentRollOver.status.classReview === "to_do") {
    currentRollOver.status.classReview = "in_review";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }
});

const confirmClassReview = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.status.classReview = "pending_job_run";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  completeClassReviewModal.value = false;
  router.push("/main/internal");
};

const learnersByGrade = ref<{ [key: number]: number }>({});

const updateLearnerCount = ({ gradeLevel, learnerCount }: { gradeLevel: number; learnerCount: number }) => {
  learnersByGrade.value[gradeLevel] = learnerCount;
};

// Grades Addition
const handleGradeCheckboxChange = (grade: number, event: Event) => {
  const target = event.target as HTMLInputElement;
  const currentlyIncluded = schoolStore.currentSchoolStructure?.gradeLevels.includes(grade);

  if (!currentlyIncluded && target.checked) {
    // User is trying to add a grade not included yet, show confirmation modal
    selectedGrade.value = grade;
    showAddGradeConfirm.value = true;
    // Temporarily revert the checkbox visually until user confirms
    target.checked = false;
  } else {
    // If it's already included and user tries to uncheck, either do nothing or revert the checkbox
    // For now, we revert to checked to prevent removal:
    if (currentlyIncluded && !target.checked) {
      target.checked = true;
    }
  }
};

const confirmSelection = async (grade: number | null) => {
  if (grade === null) return;

  // Retrieve the current school from the store
  const currentSchool = schoolStore.getCurrentSchool;

  if (!currentSchool) {
    console.error("No current school loaded");
    return;
  }

  // Take existing grade levels, add the new grade
  const updatedGradeLevels = currentSchool.gradeLevels
    ? [...currentSchool.gradeLevels, grade]
    : [grade];

  // Call the updateSchool method to persist this change
  const success = await schoolStore.updateSchool(currentSchool._id, {
    gradeLevels: updatedGradeLevels,
  });

  // Update The School Structure
  await schoolStore.fetchSchoolStructure(currentSchool._id);

  if (!success) {
    console.error("Failed to update the school with the new grade");
    // Optionally show an error message or revert the checkbox state
    return;
  }
  
  // // Add the selected grade to the school's gradeLevels array
  // const currentStructure = schoolStore.currentSchoolStructure;
  // if (currentStructure && !currentStructure.gradeLevels.includes(grade)) {
  //   currentStructure.gradeLevels.push(grade);
  //   await schoolStore.updateSchool(currentStructure); 
  //   // This should be a call to your store action or API to persist the change
  // }

  showAddGradeConfirm.value = false;
  selectedGrade.value = null;
};

const cancelSelection = () => {
  showAddGradeConfirm.value = false;
  selectedGrade.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (isInternalAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(InternalViewNav)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.title")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.sub_title")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
            }, [
              _createVNode(_unref(VideoCameraIcon), {
                class: "-ml-0.5 h-5 w-5",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("global.tutorial")), 1)
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grades), (grade) => {
          return (_openBlock(), _createElementBlock("div", { key: grade }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (
            _unref(schoolStore).currentSchoolStructure?.gradeLevels.includes(grade) &&
            (currentOpenGrade.value == grade
              ? (currentOpenGrade.value = 0)
              : (currentOpenGrade.value = grade))
          ),
              disabled: !_unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
              class: _normalizeClass([
            'accordion-title flex flex-col rounded-lg bg-white border border-[#EAECF0] mb-4 w-full px-4 py-8',
            { 
              'cursor-not-allowed opacity-70': !_unref(schoolStore).currentSchoolStructure?.gradeLevels.includes(grade)
            }
          ])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.grade")) + " " + _toDisplayString(grade), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, _toDisplayString(learnersByGrade.value[grade] || 0) + " " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.students")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      value: "",
                      class: "sr-only peer",
                      checked: _unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
                      disabled: _unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
                      onChange: ($event: any) => (handleGradeCheckboxChange(grade, $event))
                    }, null, 40, _hoisted_14),
                    _hoisted_15
                  ]),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.view")), 1),
                  (currentOpenGrade.value == grade)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
                ])
              ])
            ], 10, _hoisted_7),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(ClassStructure, {
                gradeLevel: grade,
                onUpdateLearnerCount: updateLearnerCount
              }, null, 8, ["gradeLevel"])
            ], 512), [
              [_vShow, currentOpenGrade.value == grade]
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_router_link, {
          to: "/main/incomplete-rollover",
          class: "justify-center font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-white"
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.back")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (completeClassReviewModal.value = true)),
            class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex flex-wrap disabled:opacity-50"
          }, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.confirm_email_teachers")), 1)
        ])
      ]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-2xl',
        open: showAddGradeConfirm.value,
        onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (showAddGradeConfirm.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_unref(DialogTitle), {
                as: "h3",
                class: "text-lg font-semibold text-[##101828] mb-1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.add_new_grade_header")) + "!", 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("p", _hoisted_30, [
                _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure")) + " " + _toDisplayString(selectedGrade.value), 1),
                _hoisted_31,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.to_the_program")) + "? ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelSelection()))
              }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmSelection(selectedGrade.value)))
              }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: completeClassReviewModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[7] || (_cache[7] = ($event: any) => (completeClassReviewModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (completeClassReviewModal.value = false)),
                              class: "absolute top-4 right-4"
                            }, _hoisted_37),
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.class_structure_complete"
                        )), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.final_step_text"
                        )) + ". ", 1),
                              _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.teacher_emails_text"
                        )) + ". ", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("button", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmClassReview())),
                              type: "button",
                              class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
                            }, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.confirm")), 1),
                            _createVNode(_component_router_link, { to: "/main/internal" }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_44, [
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.not_ready")) + "?", 1),
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.back_later")), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(TransitionRoot), {
        as: "template",
        show: goToAssignModal.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            as: "div",
            class: "relative z-40",
            onClose: _cache[10] || (_cache[10] = ($event: any) => (goToAssignModal.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _hoisted_47
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-out duration-300",
                    "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                    "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                    leave: "ease-in duration-200",
                    "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                    "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (goToAssignModal.value = false)),
                              class: "absolute top-4 right-4"
                            }, _hoisted_51),
                            _hoisted_52,
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold leading-6 text-[#101828]"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.almost_there"
                        )) + "!", 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.final_step_text"
                        )) + ". ", 1),
                              _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.$t(
                          "rollover.modal.review_class_structure.student_assigned_text"
                        )) + ". ", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createVNode(_component_router_link, { to: "/main/add-student" }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", _hoisted_58, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.assign")), 1)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("button", {
                              type: "button",
                              class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (goToAssignModal.value = false))
                            }, [
                              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.not_ready")) + "?", 1),
                              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.back_later")), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})